module.exports = __webpack_public_path__ + "static/a-business-executive-explains-the-titan-advantage-menu-20b80b0b6ca973c15be13db70e0e6cad.jpg";